import { render, staticRenderFns } from "./innovationAndExposure.vue?vue&type=template&id=0e7126aa&scoped=true&"
import script from "./innovationAndExposure.vue?vue&type=script&lang=js&"
export * from "./innovationAndExposure.vue?vue&type=script&lang=js&"
import style0 from "./innovationAndExposure.vue?vue&type=style&index=0&id=0e7126aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7126aa",
  null
  
)

export default component.exports